import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { isEmpty, map } from 'lodash';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import { emailRegex } from '../../../modules/regex-utils';
import Validation from '../../containers/Validation';
import Step2Task from '../../../modules/tasks/Step2Task';
import Styles from './styles';
import * as atlasOps from '../../../api/Atlas/atlas-operations';
import TaskListDataset from '../../pages/TaskListDataset';

class DatasetStepOne extends Component {
  state = {
    showModal: false,
    JsonList: [],
    listaDeElementos: [],
    AIDefault: []
  };

  async componentDidMount() {
    const { JsonList } = this.state;

    try {
      const AISettings = await methodPromise('admin.fetchAISetting');
      if (AISettings.length > 0) {
        this.setState({ AIDefault: AISettings[0] });
      }
    } catch (error) {
      handleErrorInClient(error);
    }

    this.updateInterval = setInterval(this.updateTask, 5000);
    const { gmsConnection2 } = this.props;
    if (isEmpty(JsonList) && !isEmpty(gmsConnection2)) {
      const url = `http://${atlasOps.getGMSDirection(
        gmsConnection2
      )}/AI/training/json_read_for_front`;

      const data = {
        path_json: 'IA/dataset',
        ip: false,
        port: false,
        user: false,
        password: false
      };
      const list = await methodPromise('tasks.getListJson', { data, url });

      this.setState({ JsonList: list });
    }
  }

  updateTask = async () => {
    const { gmsConnection2 } = this.props;
    if (!isEmpty(gmsConnection2)) {
      try {
        const url = `http://${atlasOps.getGMSDirection(gmsConnection2)}/AI/training/task_progress`;

        const data = {
          user: false
        };
        const list = await methodPromise('tasks.getListJson', { data, url });
        this.setState({ listaDeElementos: list });
      } catch (error) {
        handleErrorInClient(error);
        clearInterval(this.updateTask);
      }
    }
  };

  handleSubmit = async form => {
    try {
      const { gmsConnection2, atlas } = this.props;
      const emails = map(form.emailAddress.value.split(/[;,]+/), email => email.trim());
      const emailsForTask = emails.join(' ');
      const Configurations = map(form.dataset.value.split(/[;,]+/), config => config.trim());
      const DataSet = Configurations.join('');
      const SiZe = map(form.size.value.split(/[;,]+/), config => config.trim());
      const size = SiZe.join('');
      const Epoch = form.epoch.value.trim();
      const Learning = form.rate.value.trim();
      const batchSize = form.batchSize.value.trim();
      const stepEpoch = form.step_per_epoch.value.trim();
      const validationStep = form.validationStep.value.trim();
      const name = form.alias.value.trim();
      const patience = form.patience.value.trim();
      const delta = form.delta.value.trim();

      const taskToRun = Step2Task({
        owner: atlasOps.getOwner(atlas),
        taskName: name
      });

      const taskId = await methodPromise('tasks.runTask2', {
        authenticate: false,
        debugIP: isEmpty(gmsConnection2) ? '' : `${atlasOps.getGMSDirection(gmsConnection2)}`,
        isTasker: false,
        itemForOwner: { id: atlasOps.getId(atlas), collectionName: 'atlas' },
        taskToRun
      });
      const url = `http://${atlasOps.getGMSDirection(gmsConnection2)}/AI/training/exec_train`;
      const data = {
        nombre: name,
        dataset: DataSet,
        total_epochs: Epoch,
        learning_rate: Learning,
        user: 'TEST',
        email: emailsForTask,
        id: taskId,
        batch_size: batchSize,
        step_per_epoch: stepEpoch,
        validation_step: validationStep,
        ip: gmsConnection2.ip,
        size,
        patience,
        delta
      };

      this.setState({ showModal: false });
      await methodPromise('tasks.getDataset', { data, url });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openModal = () => this.setState({ showModal: true });

  closeModal = () => this.setState({ showModal: false });

  render() {
    const { isPreview, isPublic } = this.props;
    const { showModal, JsonList, listaDeElementos, AIDefault } = this.state;

    const validationProps = {
      rules: {
        alias: {
          required: true
        },
        dataset: {
          required: true
        },
        rate: {
          required: true,
          min: 0.00001,
          max: 1
        },
        epoch: {
          required: true,
          min: 1
        },
        batchSize: {
          required: true,
          min: 1
        },
        step_per_epoch: {
          required: true,
          min: 1
        },
        validationStep: {
          required: true,
          min: 1
        },
        emailAddress: {
          required: true,
          multiemails: emailRegex
        },
        size: {
          required: true
        }
      },
      messages: {
        alias: {
          required: "What's the task alias?"
        }
      },
      patience: {
        required: true,
        min: 0,
        max: 50
      },
      delta: {
        required: true,
        min: 0.1,
        max: 20
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };

    return (
      <Styles.AITaskConfigurationContainer>
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Introduce your data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Validation {...validationProps}>
              <Form onSubmit={event => event.preventDefault()}>
                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" name="alias" defaultValue="" />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Email Addresses</Form.Label>
                    <Form.Control type="text" name="emailAddress" defaultValue="" />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Dataset</Form.Label>
                    <Form.Control as="select" name="dataset" id="dataset">
                      <option value="">-</option>
                      {map(JsonList, ({ nombre, path }) => {
                        return (
                          <option value={path} key={path}>
                            {nombre}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Epoch</Form.Label>
                    <Form.Control type="number" name="epoch" defaultValue="" />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Learning Rate</Form.Label>
                    <Form.Control
                      type="number"
                      step={0.00001}
                      max={1}
                      name="rate"
                      defaultValue=""
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Batch Size</Form.Label>
                    <Form.Control
                      type="number"
                      step={1}
                      max={100}
                      name="batchSize"
                      defaultValue={AIDefault.BatchSize}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label> Step Per Epoch</Form.Label>
                    <Form.Control
                      type="number"
                      step={1}
                      max={1000}
                      name="step_per_epoch"
                      defaultValue={AIDefault.StepPerEpoch}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Validation Step</Form.Label>
                    <Form.Control
                      type="number"
                      step={1}
                      max={1000}
                      name="validationStep"
                      defaultValue={AIDefault.ValidationStep}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control as="select" name="size" id="size">
                    <option value="small">small</option>
                    <option value="nosobig">nosobig</option>
                    <option value="big">big</option>
                  </Form.Control>
                </Form.Group>

                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Patience</Form.Label>
                    <Form.Control type="number" name="patience" min={0} max={50} defaultValue="3" />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Delta</Form.Label>
                    <Form.Control
                      type="number"
                      step={0.1}
                      max={20}
                      min={0.1}
                      name="delta"
                      defaultValue="0.5"
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Col xs={{ span: 4, offset: 4 }} className="pt-3">
                    <Button block type="submit" variant="outline-success">
                      Run Detection
                    </Button>
                  </Col>
                </Form.Row>
              </Form>
            </Validation>
          </Modal.Body>
        </Modal>
        <Form.Row>
          <Form.Label column="lg" xs={12} className="mb-0 mx-1 px-3">
            Training
          </Form.Label>
        </Form.Row>
        <Row className="mb-3 pb-3">
          <Col
            xs={{ span: 4, offset: 4 }}
            sm={{ span: isPublic ? 4 : 6, offset: isPublic ? 4 : 3 }}
            md={{ span: isPublic ? 8 : 10, offset: isPublic ? 2 : 1 }}
            lg={{ span: isPublic ? 6 : 8, offset: isPublic ? 3 : 2 }}
            xl={{ span: 6, offset: 3 }}
          >
            <Button block disabled={isPreview} variant="outline-primary" onClick={this.openModal}>
              Configuration
            </Button>
          </Col>
          <TaskListDataset listaDeElementos={listaDeElementos} />
        </Row>
      </Styles.AITaskConfigurationContainer>
    );
  }
}

DatasetStepOne.propTypes = {
  aiInterestArea: PropTypes.object.isRequired,
  atlas: PropTypes.object.isRequired,
  gmsConnection: PropTypes.object.isRequired,
  gmsConnection2: PropTypes.object.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isPublic: PropTypes.bool.isRequired
};

export default DatasetStepOne;
